import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appStatusBtn]',
})
export class StatusBtnDirective implements AfterViewInit {
    @Input() color = '#4F4F4F'; // format: #ffffff
    @Input() type: 'success' | 'error' | 'default';
    @Input() showDot = true;

    private typeColorMap = new Map([
        ['success', '#27AE60'],
        ['error', '#db5757'],
        ['info', '#2F80ED'],
        ['default', '#4F4F4F'],
        ['warning', '#F2C94C'],
    ]);

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        this.elementHandler(this.el.nativeElement);
    }

    elementHandler(element: HTMLElement) {
        if (this.showDot) {
            const firstEle = element.firstChild;
            const dotSpan = document.createElement('span');
            dotSpan.setAttribute(
                'style',
                `display:inline-block; width:10px; height:10px; border-radius:50%; vertical-align:middle; margin-right:4px;
                background-color:${this.typeColorMap.get(this.type) || this.color}`
            );

            element.insertBefore(dotSpan, firstEle);
        }

        element.setAttribute(
            'style',
            `padding:4px 8px; font-size:14px; line-height:14px; border-radius:12px; white-space:nowrap;
            background-color:${this.typeColorMap.get(this.type) || this.color}1A;
            color:${this.typeColorMap.get(this.type) || this.color}`
        );
    }
}
